export default __webpack_public_path__ + "static/media/Group 85.5dcf0388.svg";